import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import { Timeline, Button, Input, ConfigProvider, Row, Col, Form } from 'antd';
import { SEARCH_ITEM_COL, TABLE_DATA_DEFAULT } from '@/scripts/config';
import useSearchList from '@/hooks/useSearchList';
import { FORM_RULE_REQUIRED } from '@/scripts/config';
import dayjs from 'dayjs';
import { FontSize } from '@icon-park/react';

const pageKey = 'ShippingLineList'; //页面身份
export default function ShippingLineList() {
    const [dataSource, setState] = useState([]);
    const [form] = Form.useForm();
    useEffect(() => {
        loading();
    }, []);

    const loading = () => {
        ajax.get('shippingLine')
            .then((response) => {
                let items = [];
                response.forEach((item) => {
                    let obj = {};
                    obj.children = item;
                    items.push(obj);
                });
                setState(items);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    // 新增航线
    const AddShippingLine = async () => {
        const formValue = await form.getFieldsValue();
        if (formValue.shipping_line) {
            ajax.post('shippingLine', { shipping_line: formValue.shipping_line })
                .then((res) => {
                    console.log(res);
                    loading();
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    return (
        <div className="list">
            <PageHeader title="航线列表" sticky></PageHeader>
            <Form form={form}>
                <Row style={{ width: '80%', display: 'flex' }}>
                    <Col style={{ width: '15%' }}>
                        <Form.Item label="航线" name="shipping_line" required rules={[FORM_RULE_REQUIRED]}>
                            <Input></Input>
                        </Form.Item>
                    </Col>
                    <Col style={{ width: '26%', marginLeft: '2%' }}>
                        <Form.Item>
                            <Button
                                onClick={AddShippingLine}
                                type="primary"
                                style={{
                                    marginBottom: 16,
                                }}
                            >
                                新增航线
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <ConfigProvider
                theme={{
                    token: {
                        fontSize: 18,
                    },
                }}
            >
                <Timeline items={dataSource} />
            </ConfigProvider>
        </div>
    );
}
